(function() {
    // Shared target date for both countdowns
    var target_date = new Date(Date.parse(new Date("December 1, 2025, 23:59 PST"))); // set the shared countdown date

    // Original countdown
    var countdown = document.getElementById("tiles"); // get tag element
    var countdownContainer = countdown ? countdown.closest('.countdown_container') : null; // get the parent countdown container
    var buttonWrapper = document.querySelector(".SectionHeader__ButtonWrapper"); // get the button wrapper element

    function pad(n) {
        return (n < 10 ? "0" : "") + n;
    }

    function updateCountdown() {
        if (!countdownContainer) {
            // The countdown element doesn't exist, so skip this function
            return;
        }

        var current_date = new Date().getTime();
        var seconds_left = (target_date - current_date) / 1000;

        if (seconds_left <= 0) {
            countdownContainer.style.display = 'none'; // Hide countdown container
            if (buttonWrapper) buttonWrapper.style.display = 'block'; // Show the button
        } else {
            countdownContainer.style.display = 'flex'; // Show countdown container
            if (buttonWrapper) buttonWrapper.style.display = 'none'; // Hide the button before time
            // Update countdown
            days = pad(parseInt(seconds_left / 86400));
            seconds_left %= 86400;

            hours = pad(parseInt(seconds_left / 3600));
            seconds_left %= 3600;

            minutes = pad(parseInt(seconds_left / 60));
            seconds = pad(parseInt(seconds_left % 60));

            countdown.innerHTML = "<span>" + days + "</span><span>" + hours + "</span><span>" + minutes + "</span><span>" + seconds + "</span>";
        }
    }

    // Set interval to update the original countdown only if it exists
    if (countdown) {
        setInterval(updateCountdown, 1000);
        updateCountdown(); // Also update on initial load
    }

    // Banner countdown
    var bannerCountdown = document.getElementById("countdown_tiles"); // get the banner countdown element
    var bannerContainer = bannerCountdown.closest('#countdown'); // get the parent countdown container for the banner

    function updateBannerCountdown() {
        var current_date = new Date().getTime();
        var seconds_left = (target_date - current_date) / 1000;

        if (seconds_left <= 0) {
            bannerContainer.style.display = 'none'; // Hide the banner countdown container
        } else {
            bannerContainer.style.display = 'inline-block'; // Show the banner countdown container

            // Update banner countdown
            days = pad(parseInt(seconds_left / 86400));
            seconds_left %= 86400;

            hours = pad(parseInt(seconds_left / 3600));
            seconds_left %= 3600;

            minutes = pad(parseInt(seconds_left / 60));
            seconds = pad(parseInt(seconds_left % 60));
            bannerCountdown.innerHTML = "<span> — ENDS IN " + days + "</span><span>:</span><span>" + hours + "</span><span>:</span><span>" + minutes + "</span><span>:</span><span>" + seconds + "</span>";
        }
    }

    // Set interval to update the banner countdown every second
    setInterval(updateBannerCountdown, 1000);
    updateBannerCountdown(); // Also update the banner countdown on initial load
})();

